import React from 'react';
import Markdown from '../../../components/markdown';
import { useFetchDocuments } from '../../../hooks/documents/use-fetch-documents';

const Terms: React.FC = () => {
  const { content } = useFetchDocuments('terms');

  return <Markdown content={content} />;
};

export default Terms;
